<router-outlet></router-outlet>
<u-cookie-banner *ngIf="!isServer"></u-cookie-banner>
